import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button, Row, Col, Container, Form, Table } from "react-bootstrap"
import axios from "axios";
import toast from "react-hot-toast";
import ToastComponent from "./components/ToastComponent";
import LoadingSpinner from "./components/Helpers/LoadingSpinner";
import Panel from "./components/Panel";

function HaDeviceShow() {
  const [hadevice, setHadevice] = useState();

  let { id } = useParams();

  const getdevice = () => {
    axios
    .get(`${process.env.REACT_APP_API ? process.env.REACT_APP_API : window.location.origin}/gui/v1/ha_device/${id}.json`)
    .then(({ data }) => {
      setHadevice(data)
    })
  }

  const removeCustomer = () => {
    axios
    .post(`${process.env.REACT_APP_API ? process.env.REACT_APP_API : window.location.origin}/gui/v1/ha_device/${id}.json`, {
      customer_id: null
    })
    .then(({ data }) => {
      getdevice();
    })
  }
  useEffect(() => {
    getdevice();
  }, []);
  
if (!hadevice) {
  return <LoadingSpinner />
}

  return (
    <div>
      <Container>
        <Panel>
        <Table >
          <tr>
            <td>ID</td>
            <td>{hadevice.id}</td>
          </tr>
          <tr><td><strong>Customer</strong></td>
          <td>{hadevice.customer_id ? <><a href={`/customer/${hadevice.customer_id}`}>{hadevice.customer.surname} {hadevice.customer.first_name}</a> <Button onClick={() => removeCustomer()} variant="danger">Remove</Button></> : <>unassigned</>}</td>
          </tr>
          <tr>
            <td>Name</td>
            <td>{hadevice.name}</td>
          </tr>
          <tr>
            <td>URL</td>
            <td>{hadevice.url}</td>
          </tr>
          <tr>
            <td>IP Address</td>
            <td>{hadevice.ipaddress}</td>
          </tr>
          <tr>
            <td>Public Key</td>
            <td>{hadevice.interface_publickey}</td>
          </tr>
          <tr>
            <td>Peers Config</td>
            <td><pre>{hadevice.peers_config}</pre></td>
          </tr>
          <tr>
            <td>Interface Config</td>
            <td><pre>{hadevice.interface_config}</pre></td>
          </tr>

        </Table>
        </Panel>
      </Container>
    </div>

  )
}

export default HaDeviceShow